import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { API_BASE, FILE_API_BASE_URL, MAX_CACHE_SIZE } from '@progressio/client-toolkit';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { OAuthService, provideOAuthClient } from 'angular-oauth2-oidc';
import { initAuth } from './app.util';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

export const appConfig: ApplicationConfig = {
  providers: [
    // Core Angular providers
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
    }),

    // Environment configuration
    { provide: API_BASE, useValue: environment.apiBase },
    { provide: MAX_CACHE_SIZE, useValue: environment.maxCacheSize },
    { provide: FILE_API_BASE_URL, useValue: environment.fileBase },
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/assets/i18n/',
        suffix: '.json',
      },
    },

    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader,
        },
      })
    ),

    // Authentication with built-in interceptor
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [environment.apiBase],
        sendAccessToken: true,
      },
    }),
    provideAppInitializer(() => initAuth(inject(OAuthService))()),
  ],
};
